import React, { useEffect } from 'react';
import useConsentCheck from 'hooks/use-consent-check';
import useClient from 'hooks/use-client';
import ErrorCookiesSettings from '../error-cookies-settings/error-cookies-settings';
import Delay from '../delay/delay';

const YotpoReviewsWidget = (props) => {
  const {
    consentCode,
    errorText,
    widgetId,
    productId,
    productTitle,
    productUrl,
    imageUrl,
    price,
    currency,
    description,
  } = props;
  const isConsentGranted = useConsentCheck(consentCode);
  const isClient = useClient();

  useEffect(() => {
    if (window.yotpoWidgetsContainer?.initWidgets && isConsentGranted) {
      window.yotpoWidgetsContainer.initWidgets();
    }
  }, [productId, isConsentGranted]);

  return (
    <div>
      {isClient && !isConsentGranted && (
        <Delay waitTime={500}>
          <ErrorCookiesSettings errorText={errorText} />
        </Delay>
      )}
      {isConsentGranted && (
        <div
          className="yotpo-widget-instance"
          data-yotpo-instance-id={widgetId}
          data-yotpo-product-id={productId}
          data-yotpo-name={productTitle}
          data-yotpo-url={productUrl}
          data-yotpo-image-url={imageUrl}
          data-yotpo-price={price}
          data-yotpo-currency={currency}
          data-yotpo-description={description}
        ></div>
      )}
    </div>
  );
};

export default YotpoReviewsWidget;
